export const apiConstants = {
  auth: '/auth/sign-in',
  me: '/me',
};
